import HyperlinkLink from '@databases/content-link/HyperlinkLink';
import { ViewComponentProps } from '@databases/fields/view/types';
import { Hyperlink } from '@databases/types/database';
import { DatabaseFieldType } from '@databases/types/database';
import { isValidHyperlinkUrl } from '@databases/utils/utils';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.ul`
  list-style-type: none;
  padding: 0;
  width: 100%;

  > li + li {
    margin-top: 6px;
  }
`;

const preventDefault = (e: React.MouseEvent | React.FocusEvent) => {
  // Prevent propagation to inline edit
  e.stopPropagation();
};

export const makeValidHyperlink = (v: Hyperlink) => {
  if (v.url && !isValidHyperlinkUrl(v.url)) {
    return { ...v, url: `https://${v.url}` };
  }

  return v;
};

const HyperlinkValueView: FunctionComponent<
  ViewComponentProps<DatabaseFieldType.HYPERLINK>
> = ({ field, value, noFocus }) => {
  return (
    <Container>
      {value.map(makeValidHyperlink).map((v, i) => (
        <li key={i}>
          <HyperlinkLink
            hyperlink={v}
            noFocus={noFocus}
            onClick={preventDefault}
            onFocus={preventDefault}
            noResolve={!field.settings.resolve}
            useSmartLink
          />
        </li>
      ))}
    </Container>
  );
};

export default HyperlinkValueView;
